import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bed1ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-red-600 font-semibold md:text-lg text-md" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorText',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(props.text), 1)
  ]))
}
}

})